import { css } from "styled-components";

import { breakpoints } from "common/styles/mediaQueries/breakpoints";
import type { ScreenSize } from "common/styles/mediaQueries/types";
import { unsafelyEntries } from "common/utilities/object";

type Style = { spacing: number };

export const breakpointStyles: Record<ScreenSize, Style> = {
  small: { spacing: 1 },
  medium: { spacing: 2 },
  large: { spacing: 2 },
  extraLarge: { spacing: 3 },
  enormous: { spacing: 3 },
};

export const mediaStyles = (
  getValue: (style: Style) => string,
  styles: Partial<Record<ScreenSize, Style>> = breakpointStyles,
) =>
  unsafelyEntries(styles).map(([key, value]) =>
    value === undefined
      ? css``
      : key === "small"
        ? css`
            ${getValue(value)};
          `
        : css`
            @media ${breakpoints[key]} {
              ${getValue(value)};
            }
          `,
  );
